// One request in flight, latest wins. While a request runs only the NEWEST argument is kept;
// when the running one finishes the newest (if any) is sent. A slider drag fires dozens of input
// events — queueing them all makes the view lag seconds behind the finger.
//   send(arg) → Promise<reply>;  onReply(arg, reply) is called for EVERY finished request, in order;
//   the consumer drops stale replies itself (session.settle does, by document identity).
export function latestWins(send, onReply, onIdle = () => {}) {
  let running = false, queued = null, hasQueued = false;
  async function pump(arg) {
    running = true;
    try {
      for (;;) {
        let reply;
        try { reply = await send(arg); } catch (e) { reply = { ok: false, error: { code: 'internal', message: String(e && e.message || e) } }; }
        try { onReply(arg, reply); } catch (e) { console.error('latestWins: onReply threw', e); }   // a throwing consumer must not kill the pump — a queued arg would be lost
        if (!hasQueued) break;
        arg = queued; queued = null; hasQueued = false;
      }
    } finally { running = false; onIdle(); }
  }
  return (arg) => {
    if (running) { queued = arg; hasQueued = true; return; }
    pump(arg);
  };
}
